import { Dispatch, SetStateAction, useEffect } from 'react';
import { ICluster, IMapSettings } from '../views/components/Video/MapComponent';
import {GeoFilter} from "../shared/models/Geo";
import {LatLng} from "leaflet";
import {parseTransportCoords} from "../views/components/Video/MapComponent/utils/parseTransportCoords";

type UseVehiclesFromEventSourceProps = {
  filteredVehicles: number[] | null;
  mapSettings: IMapSettings;
  setClusters: Dispatch<SetStateAction<ICluster[]>>;
};

export const useVehiclesFromEventSource = ({
  filteredVehicles,
  mapSettings,
  setClusters
}: UseVehiclesFromEventSourceProps) => {
  useEffect(() => {
    const mapFilter = new GeoFilter();

    if (mapSettings.bounds) {
      mapFilter.region = mapSettings.bounds.map((latLng: LatLng) => ({
        longitude: latLng.lat,
        latitude: latLng.lng,
      }));
      mapFilter.zoom = mapSettings.zoom;

      mapFilter.vehicles = filteredVehicles;

      const geoEventSource = new EventSource(
        `/geoapi/v1/geo/1?q=${mapFilter.serialize()}`
      );
      geoEventSource.onmessage = (event) => {
        const parsed = JSON.parse(event.data);
        if (parsed !== null) {
          setClusters(parseTransportCoords(parsed));
        } else {
        }
      };
      return () => {
        geoEventSource.close();
      };
    }
  }, [filteredVehicles, mapSettings.bounds, mapSettings.zoom, setClusters]);
};
